import { render, staticRenderFns } from "./News375.vue?vue&type=template&id=62415dbc&scoped=true"
import script from "./News375.vue?vue&type=script&lang=js"
export * from "./News375.vue?vue&type=script&lang=js"
import style0 from "./News375.vue?vue&type=style&index=0&id=62415dbc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62415dbc",
  null
  
)

export default component.exports